import api from "./api";

export const getSecurityCenterData = async () => {
    const [systemLogsRes, blockchainRes, iotRes, usersRes] =
        await Promise.allSettled([
            api.get("/SystemLog"),
            api.get("/BlockchainLog"),
            api.get("/IoTDevice"),
            api.get("/Admin/users"),
        ]);

    const systemLogs =
        systemLogsRes.status === "fulfilled" && Array.isArray(systemLogsRes.value.data)
            ? systemLogsRes.value.data
            : [];

    const blockchainLogs =
        blockchainRes.status === "fulfilled" && Array.isArray(blockchainRes.value.data)
            ? blockchainRes.value.data
            : [];

    const devices =
        iotRes.status === "fulfilled" && Array.isArray(iotRes.value.data)
            ? iotRes.value.data
            : [];

    const users =
        usersRes.status === "fulfilled" && Array.isArray(usersRes.value.data)
            ? usersRes.value.data
            : [];

    const failedLogins = systemLogs.filter((x) =>
        JSON.stringify(x).toLowerCase().includes("failed")
    ).length;

    const blockedUsers = users.filter((u) =>
        u.isBlocked || u.lockoutEnabled || u.disabled
    ).length;

    const onlineDevices = devices.filter((d) => {
        if (!d.lastUpdated) return false;
        return Date.now() - new Date(d.lastUpdated).getTime() < 2 * 60 * 1000;
    }).length;

    return {
        apiStatus: "Online",
        jwtStatus: "Active",
        twoFactorStatus: "Enabled",
        encryptionStatus: "Active",
        failedLogins,
        blockedUsers,
        users: users.length,
        iotDevices: devices.length,
        onlineDevices,
        blockchainEvents: blockchainLogs.length,
        threatScore: failedLogins > 5 ? 35 : 8,
        securityEvents: systemLogs.slice(0, 10),
    };
};

export default {
    getSecurityCenterData,
};